import { render, staticRenderFns } from "./BigNavIcon.vue?vue&type=template&id=1560bf42&scoped=true&"
import script from "./BigNavIcon.vue?vue&type=script&lang=js&"
export * from "./BigNavIcon.vue?vue&type=script&lang=js&"
import style0 from "./BigNavIcon.vue?vue&type=style&index=0&id=1560bf42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1560bf42",
  null
  
)

export default component.exports